import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'

import './styles.scss'
import { useWindowSize } from 'hooks'
import DotsButton from 'components/Buttons/DotsButton'
import OptionsTooltip from './OptionsTooltip'

const DotsOptionsSelector = ({
  isOpen,
  toggle,
  options = [],
  position = 'top',
  dotsPosition = 'horizontal',
  dotsColor = '#999999',
  className
}) => {
  const [selectorCoords, setSelectorCoords] = useState(undefined)
  const [modalVisible, setModalVisible] = useState(false)
  const selectorRef = useRef(null)
  const modalPortal = document.getElementById('modal-portal')
  const size = useWindowSize()

  useEffect(() => {
    if(selectorRef && selectorRef.current) {
      setSelectorCoords(selectorRef.current.getBoundingClientRect())
    }
  }, [selectorRef, size, isOpen])

  useEffect(() => {
    if (isOpen) {
      modalPortal.style.display = 'flex'
      setModalVisible(true)
    } else {
      modalPortal.style.display = 'none'
      setModalVisible(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <>
      <div ref={selectorRef} className={`dots-options-selector ${className || ''}`}>
        <DotsButton
          orientation={dotsPosition}
          color={dotsColor}
          onClick={toggle}
        />
      </div>
      {isOpen && selectorCoords && modalVisible && ReactDOM.createPortal(
        <OptionsTooltip
          modalPortal={modalPortal}
          selectorCoords={selectorCoords}
          options={options}
          position={position}
          toggle={toggle}
        />, modalPortal
      )}
    </>
  )
}

export default DotsOptionsSelector
